import { useTranslation } from "react-i18next";

import { IconSprite } from "../../../../../../../components/ui/IconSprite/IconSprite";

import {
  ArticleDescription,
  ArticleTitle,
  CardItem,
  Link,
} from "./OtherArticleCardItem.styled";

const OtherArticleCardItem = ({ link, title, description, lang }) => {
  const { t } = useTranslation();

  return (
    <CardItem>
      <ArticleTitle>{title}</ArticleTitle>
      <ArticleDescription>{description}</ArticleDescription>

      <Link
        to={`/${lang}blog/${link}/`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <IconSprite tag="eys" width="20" height="21" />
        <p>{t("global.view")}</p>
      </Link>
    </CardItem>
  );
};

export default OtherArticleCardItem;
